<template>
  <zm-button
    data-testid="checkout-button-476"
    :data-url='targetUrl'
    data-cta-type='1'
    size='lg'
    :icon="DownloadLocalSmall"
    type="secondary"
    class='opc-succezz_download-action'
    @click='handleDownload'>
    {{ $t('billing.success.confirmation.download_zoom') }}
  </zm-button>
</template>
<script>
import { getEmailCTAsTrackingUrl, UTM_CONTENT_CODE } from '@/views/succezz/utils/email-ctas-tracking';
import { DownloadLocalSmall } from '@zoom/icons-vue';

export default {
  data() {
    return {
      jumpUrl: '/support/download',
      DownloadLocalSmall
    }
  },
  computed: {
    targetUrl() {
      return getEmailCTAsTrackingUrl(this.jumpUrl, { utmContent: UTM_CONTENT_CODE.downloadZoom });
    }
  },
  methods: {
    handleDownload() {
      this.$tracking.buyInteraction('purchase confirmation', 'download zoom');
      window.open(this.jumpUrl, "_blank");
    },
  },
};
</script>
